import { redirect } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { userProfileKeys } from '@/lib/hooks/useUserProfile';
import { getUserProfile } from '@/lib/services/userProfiles';

type AdminRouteContext = {
  auth: {
    user: { id: string } | null;
  };
  queryClient: QueryClient;
};

export async function requireAdminRoute(context: AdminRouteContext) {
  const userId = context.auth.user?.id;
  const profile = await context.queryClient.ensureQueryData({
    queryKey: userProfileKeys.current(userId || ''),
    queryFn: () => getUserProfile(userId),
  });

  if (profile?.role !== 'admin') {
    throw redirect({ to: '/' });
  }
}
